import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import { Typography } from '@material-ui/core';
import { indigo } from '@material-ui/core/colors';
import useStyles from './CircularBar.styles';

const CircularBar = props => {
  const {
    className,
    value,
    size,
    strokeWidth,
    strokeLinecap,
    strokeOuterColor,
    strokeInnerColor,
    textComponent,
    textVariant,
    textColor,
    ...rest
  } = props;
  const classes = useStyles();

  return (
    <div {...rest} className={cn(classes.root, className)} style={{ width: size, height: size }}>
      <Typography
        component={textComponent}
        variant={textVariant}
        color={textColor}
        className={classes.text}
      >
        {value}
      </Typography>
      <svg viewBox="0 0 36 36">
        <path
          className={classes.circle1}
          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          stroke={strokeOuterColor}
          strokeDasharray="100, 100"
          strokeWidth={strokeWidth}
          strokeLinecap={strokeLinecap}
        />
        <path
          className={classes.circle2}
          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          stroke={strokeInnerColor}
          strokeDasharray={`${value}, 100`}
          strokeWidth={strokeWidth}
          strokeLinecap={strokeLinecap}
        />
      </svg>
    </div>
  );
};

CircularBar.propTypes = {
  value: Type.number.isRequired,
  size: Type.number,
  strokeWidth: Type.number,
  strokeLinecap: Type.oneOf(['round', 'square']),
  strokeOuterColor: Type.string,
  strokeInnerColor: Type.string,
  textColor: Type.oneOf([
    'initial',
    'inherit',
    'primary',
    'secondary',
    'textPrimary',
    'textSecondary',
    'error',
  ]),
  textVariant: Type.oneOf([
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'caption',
    'button',
    'overline',
    'srOnly',
    'inherit',
  ]),
  textComponent: Type.string,
  className: Type.string,
};

CircularBar.defaultProps = {
  size: 36,
  strokeWidth: 3,
  strokeOuterColor: 'rgba(0,0,0,0.05)',
  strokeInnerColor: indigo[500],
  strokeLinecap: 'round',
  textVariant: 'h5',
  textComponent: 'span',
  textColor: 'textPrimary',
  className: null,
};

export default CircularBar;
